import { __module as t } from "../../../_virtual/isRgbColor.js";
import { a as e } from "./util/assertString.js";
Object.defineProperty(r = t.exports, "__esModule", {
  value: !0
}), r.default = function (t) {
  var e = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1];
  return ((0, s.default)(t), e) ? o.test(t) || a.test(t) || l.test(t) || u.test(t) : o.test(t) || a.test(t);
}, s = e && e.__esModule ? e : {
  default: e
}, o = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, a = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, l = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)/, u = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)/, t.exports = r.default, t.exports.default = r.default;
var r,
  s,
  o,
  a,
  l,
  u,
  d = t.exports;
export { d as i };